import { useDroppable } from '@dnd-kit/react';
import { cn } from '@repo/lib/cn';

import type { DroppableAreaProps } from '.';

export function DroppableArea(droppableAreaProps: DroppableAreaProps) {
  const { className, isOverClassName, droppableProps, ...props } = droppableAreaProps;
  const { ref: setNodeRef, isDropTarget } = useDroppable(droppableProps);

  return <div ref={setNodeRef} className={cn(className, isDropTarget && isOverClassName)} {...props} />;
}
